const getSettings = (state) => {
  return state.settings
}

const getCheckpointWording = (state) => {
  return state.settings.checkpoint_wording || 'checkpoint'
}

const getCheckpointWordingPlural = (state) => {
  return state.settings.checkpoint_wording_plural || 'checkpoints'
}

const getStrollWording = (state) => {
  return state.settings.stroll_wording || 'stroll'
}

const getStrollWordingPlural = (state) => {
  return state.settings.stroll_wording_plural || 'strolls'
}

const getMapCentre = (state) => {
    return state.settings.map_centre.coordinates
}

const getMapZoomLevel = (state) => {
  return state.settings.map_zoom_level
}

const getMapMaxZoom = (state) => {
  return state.settings.map_max_zoom
}

const getHasDisclaimer = (state) => {
  return state.settings.has_disclaimer
}

const getDisclaimer = (state) => {
  return state.settings.disclaimer
}

export const getters = {
  getSettings,
  getCheckpointWording,
  getCheckpointWordingPlural,
  getMapCentre,
  getMapZoomLevel,
  getMapMaxZoom,
  getStrollWording,
  getStrollWordingPlural,
  getHasDisclaimer,
  getDisclaimer,
}

